export default {
  title: 'Rozpocznij subskrypcję',
  title_confirm: 'Potwierdź swój plan',
  step: 'Krok {{current}} z {{total}}',
  subtitle: '{{name}} · 1 lokalizacja',
  trial_badge: '{{days}} dni za darmo',
  trial_headline: 'Pierwsze {{days}} dni za darmo',
  then_price: 'Następnie {{price}} / miesiąc za lokalizację · z uwzględnieniem podatku',
  price_per_month: '{{price}} / miesiąc',
  price_terms: 'Za lokalizację, rozliczane miesięcznie · z uwzględnieniem podatku',
  tier_upsell:
    'Skaluj do {{threshold}}+ aktywnych lokalizacji, a stawka dla wszystkich Twoich lokalizacji spadnie do {{price}} / miesiąc za lokalizację — automatycznie.',
  tier_active: 'Stawka wolumenowa — {{threshold}}+ aktywnych lokalizacji',
  due_today: 'Do zapłaty dziś',
  from_date: 'Od {{date}}',
  no_charge_today: 'Dziś nie zostaniesz obciążony opłatą.',
  no_charge_until: 'Nie zostaniesz dziś obciążony opłatą. Anuluj do {{date}}, a nic nie zapłacisz.',
  active: '{{plan}} jest aktywny dla tej restauracji.',
  active_with_trial: '{{plan}} jest aktywny dla tej restauracji, bezpłatnie do {{date}}.',
  terms:
    'Akceptuję <a href="{{terms_url}}" target="_blank" rel="noreferrer">Warunki platformy partnerskiej FoodAmigos</a>, w tym zasady aktywacji, anulowania i zwrotów.',
  error: 'Nie udało się sfinalizować zakupu. Spróbuj ponownie.',
  loading: 'Sprawdzanie planu tej restauracji…',
  load_error: 'Nie udało się sprawdzić planu tej restauracji.',
  unavailable: 'Ten produkt jest niedostępny dla tej restauracji. Skontaktuj się z opiekunem konta FoodAmigos.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Zamawianie online',
          description: 'Bezpośrednie zamówienia na własnej stronie restauracji',
        },
        reservations: {
          title: 'Rezerwacje stolików',
          description: 'Goście rezerwują stolik bezpośrednio online',
        },
        marketing: {
          title: 'Marketing Suite',
          description: 'Kreator ofert, program lojalnościowy i odpowiedzi AI na opinie Google',
        },
        pricing: {
          title: '0% prowizji, brak opłaty za wdrożenie',
          description: 'Jedna licencja na lokalizację, rozliczana miesięcznie',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'Własna markowa aplikacja restauracji',
          description: 'W App Store i Google Play',
        },
        engagement: {
          title: 'Powiadomienia push i lojalność',
          description: 'Przyciągaj gości z powrotem ofertami i punktami',
        },
        ordering: {
          title: 'Zamawianie z 0% prowizji',
          description: 'Bezpośrednie zamówienia prosto z aplikacji',
        },
        apple: {
          title: 'Wymagane konto Apple Developer',
          description: '99 USD/rok, płatne na rzecz Apple, w ramach podmiotu prawnego restauracji',
        },
      },
    },
    ai_website: {
      title: 'Subskrypcja Kreatora Stron',
      subtitle_domain: 'Uruchom stronę {{name}} pod adresem {{domain}}',
      features: {
        domain: {
          title: 'Twoja strona, na własnej domenie',
          description: 'Markowa strona restauracji',
        },
        ai: {
          title: 'Tworzona i aktualizowana przez AI',
          description: 'Twórz strony, teksty i obrazy dla restauracji w kilka minut',
        },
        ordering: {
          title: 'Wbudowane zamawianie i rezerwacje',
          description: 'Goście zamawiają i rezerwują stolik bezpośrednio ze strony',
        },
        pricing: {
          title: 'Brak opłaty za wdrożenie',
          description: 'Jedna licencja na lokalizację, rozliczana miesięcznie',
        },
      },
    },
    storefront: {
      title: 'Subskrypcja Kreatora Stron',
      subtitle_domain: 'Uruchom stronę {{name}} pod adresem {{domain}}',
      features: {
        domain: {
          title: 'Twoja strona, na własnej domenie',
          description: 'Markowa strona restauracji',
        },
        ai: {
          title: 'Tworzona i aktualizowana przez AI',
          description: 'Twórz strony, teksty i obrazy dla restauracji w kilka minut',
        },
        ordering: {
          title: 'Wbudowane zamawianie i rezerwacje',
          description: 'Goście zamawiają i rezerwują stolik bezpośrednio ze strony',
        },
        pricing: {
          title: 'Brak opłaty za wdrożenie',
          description: 'Jedna licencja na lokalizację, rozliczana miesięcznie',
        },
      },
    },
  },
  payment_method: {
    label: 'Metoda płatności partnera',
    on_file: 'Karta zapisana w systemie',
    pending_title: 'Potwierdzanie metody płatności',
    pending: 'Stripe wciąż potwierdza dodaną przez Ciebie kartę. Może to potrwać chwilę.',
    still_pending: 'Jeszcze nie teraz. Daj chwilę i sprawdź ponownie.',
    error: 'Nie udało się otworzyć formularza płatności. Spróbuj ponownie.',
  },
  buttons: {
    close: 'Zamknij',
    continue_to_payment: 'Przejdź do płatności',
    start_trial: 'Rozpocznij {{days}}-dniowy okres próbny',
    subscribe: 'Rozpocznij subskrypcję',
    continue: 'Dalej',
    change: 'Zmień',
    retry: 'Spróbuj ponownie',
    check_again: 'Sprawdź ponownie',
    add_again: 'Dodaj kartę ponownie',
  },
};
